import axios from "axios";
import React, {useEffect, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function EnviarRecibo() {
    const location = useLocation();
    const { registro } = location.state || {};
    //console.log(registro);
    const navigate = useNavigate();
    const uuid = location.pathname.split('/')[2];
    
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [errorMessage, setErrorMessage] = useState('');
    
    const [file, setFile] = useState(null);
    const [PdfFile, setPdfFile] = useState({
            NomePdf: '',
            Arquivo: ''
        });
    const [uploadStatus, setUploadStatus] = useState('');

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const guid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
        

    function handleFecharModal(){
        window.history.back();
    }

    function handleFormSubmit(event) {
        event.preventDefault();
        // Aqui você pode adicionar a lógica para enviar o recibo, como uma chamada à API
        if (!file) {
            setErrorMessage('Por favor, selecione um arquivo para enviar.');
            return;
        }
        // Lógica para enviar o arquivo selecionado
        const formData = new FormData();
        formData.append('documento', file);
        formData.append('uuid', uuid);
        
        axios.post(process.env.REACT_APP_API_URL + '/routes.php?metodo=uploadDocumentoMensalidade', formData, {
            headers: {
                "X-Access-Token" : tokenAPI,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            //console.log(response.data);
            setUploadStatus('Recibo enviado com sucesso!');
            registro.mslRecibo = response.data.filePath; // Atualiza o caminho do recibo no registro
            salvarMensalidade();
        })
        .catch(error => {
            console.error('Erro ao enviar o recibo:', error);
            setUploadStatus('Erro ao enviar o recibo. Por favor, tente novamente.');
            return;
        });
        alert("Formulário enviado!");
    }

    var bloqueio = false;

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    function salvarMensalidade() {
        let url = "";
        const data = {
                IdMensalidade: registro.IdMensalidade,
                IdPessoa: registro.IdPessoa,
                mslMes: registro.mslMes,
                mslAno: registro.mslAno,
                mslMesAno: registro.mslMesAno,
                mslValor: registro.mslValor,
                mslRecibo: registro.mslRecibo,
                mslStatus: registro.mslStatus,
                mslObservacoes: registro.IdMensalidade === 0 ? "Gerada via envio de recibo." : registro.mslObservacoes,
                mslCriadoPor: registro.IdMensalidade === 0 ? sessionStorage.nomeUsuario : registro.mslCriadoPor,
                mslCriadoEm: registro.IdMensalidade === 0 ? customFormatDate : registro.mslCriadoEm,
                mslAlteradoPor: sessionStorage.nomeUsuario,
                mslAlteradoEm: customFormatDate,
                mslCodigoGUID: registro.IdMensalidade === 0 ? guid : registro.mslCodigoGUID
            };
        
        if (parseInt(registro.IdMensalidade) === 0) {
            url = process.env.REACT_APP_API_URL + '/routes.php?metodo=novaMensalidade';
        }
        else {
            url = process.env.REACT_APP_API_URL + '/routes.php?metodo=atualizarMensalidade';
        }
// console.log("Dados a serem enviados para a API:", data);
// console.log("URL da API:", url);
//return;
        axios.post(url, 
        data, {
        headers: {
            "X-Access-Token" : tokenAPI,
            'Content-Type': 'application/json; charset=UTF-8'
        }
        })
        .then(response => {
            //console.log(response.data);
            alert('Mensalidade atualizada com sucesso!');
            //window.history.back();
            if(sessionStorage.reciboOrigem === "AreaDoAssociado") {
                window.history.back();
            } else if (sessionStorage.reciboOrigem === "Mensalidade") {
                navigate('/Mensalidade/' + registro.mslAno + '/' + registro.mslMes);
            }
        })
        .catch(error => {
            console.error('Erro ao atualizar a mensalidade:', error);
            alert('Erro ao atualizar a mensalidade. Por favor, tente novamente.');
        }); 
        }
    
    return (
        <>
            <main>
                <div>
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-leeft w80'>
                            <button
                                className="fs14 clrWhite"
                                onClick={handleFecharModal}
                                style={{ backgroundColor: '#2c2f2c', color: '#fff', border: '1px solid #6f6b6b', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}
                                >
                                    Voltar
                            </button>
                        </div>
                    </div>
                    <div className='headerMain'>
                        <label className='labelTitulo' ></label>
                        <h3>Envio do recibo de confirmação</h3>
                    </div>
                </div>

                <form onSubmit={handleFormSubmit}>
                    <div className='headerMain'>
                        <h5>Associado: {registro.pesNome}</h5>
                        <label className='labelTitulo' >Recibo ref. mês {registro.mslMes} de {registro.mslAno}</label>
                    </div>
                    <div className="d-flex w100 flex-column tdAlignLeft pb4"> 
                        <div className="d-flex flex-column divForm">
                                <div className='text-align-left w100 divForm fs16'>
                                    <label>DOCUMENTO</label>
                                </div>
                                {parseInt(sessionStorage.pesAdmin) === 1 
                                || parseInt(sessionStorage.IdPessoa) === registro.IdPessoa ? (
                                <div className='text-align-center divForm w100 fs12'>
                                    <input
                                    type="file"
                                    name="mslRecibo"
                                    className="p1 bgGray fs12 w100"
                                    id="mslRecibo"
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    onChange={handleFileChange}/>
                                    <p>{uploadStatus}</p>
                                </div> ) : ('') } 
                                <div className='text-align-left divForm w100 fs10'>
                                    <label>{registro.mslRecibo.replace('uploads/lancamentos/','')}</label>
                                </div>
                            </div>
                        <div className='text-align-left mt2 mb4 divForm fs14'>
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || parseInt(sessionStorage.IdPessoa) === registro.IdPessoa ? (
                            <button 
                                className='buttonModalPadrao pt1 pb2 w100 fs14'
                                type="submit">
                                    ENVIAR RECIBO
                            </button> ) : ('') } 
                        </div>
                    </div>
                </form>
            </main>
        </>
        
    );
}
